<div class="row">	
	<div class="col">
		<div class="row summary-body">
			<div class="col">
				<div class="row">
					<div class="col summary-body-title">
						<span class="summary-title">{{'USER_REF' | translate}}:</span> {{userRef}}
					</div>
				</div>
				<div class="row">
					<div class="col">
						<div *ngFor="let field of textFields" class="row">
							<div class="col summary-title">
								{{field.field}}
							</div>
							<div class="col" [ngSwitch]="field.inputField">
								<div *ngSwitchCase="'date'">
									{{util.parseDate(field.value)}}
								</div>
								<div *ngSwitchDefault>
									{{util.parsePossibleBoolean(field.value)}}
								</div>
							</div>
						</div>
					</div>
					<div class="col">
						<div class="row">
							<img *ngIf="image" [src]="image" class="summary-image" />
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col text-center">
						<img *ngIf="qrImage" [src]="qrImage" />
						<qrcode *ngIf="!qrImage" [qrdata]="getQrData()" [width]="256" [errorCorrectionLevel]="'M'"></qrcode>
					</div>
				</div>
				<div class="row">
					<div class="col text-center">
						<span class="summary-title">{{'SELF_SERVICE_TOKEN' | translate}}:</span> {{axonId}}<br/>
						<span class="summary-title">{{'SELF_SERVICE_PIN' | translate}}:</span> {{pin}}
					</div>
				</div>
			</div>
		</div>
	</div>
</div>